import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React, { useCallback } from "react"
import { playerStore } from "src/store/PlayerStore"

import useTranslate, { Namespaces } from "../../../../hooks/use-translate"
import { s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"

export const TracksButton = ({ focusKey }: { focusKey?: string }) => {
  const setTrackSelectOpen = playerStore((state) => state.setTrackSelectOpen)
  const t = useTranslate(Namespaces.Common)

  const onPress = useCallback(() => {
    setTrackSelectOpen(true)
  }, [setTrackSelectOpen])

  const { focused, ref, focusSelf } = useFocusable({
    focusKey: focusKey,
    onEnterPress: onPress,
  })
  return (
    <Box
      sx={{ height: s("72px"), width: s("72px") }}
      tabIndex={0}
      aria-label={t("player__button_list")}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      <svg
        width={s("72")}
        height={s("72")}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="36"
          cy="36"
          r="36"
          fill={focused ? "white" : theme.palette.new.playerButton}
        />
        <path
          d="M30.2432 29.8467C29.8525 29.8467 29.5205 29.71 29.2471 29.4365C28.9834 29.1631 28.8516 28.8311 28.8516 28.4404C28.8516 28.0498 28.9834 27.7227 29.2471 27.459C29.5205 27.1855 29.8525 27.0488 30.2432 27.0488H49.0371C49.4277 27.0488 49.7549 27.1855 50.0186 27.459C50.292 27.7227 50.4287 28.0498 50.4287 28.4404C50.4287 28.8311 50.292 29.1631 50.0186 29.4365C49.7549 29.71 49.4277 29.8467 49.0371 29.8467H30.2432ZM30.2432 38.4014C29.8525 38.4014 29.5205 38.2695 29.2471 38.0059C28.9834 37.7324 28.8516 37.4004 28.8516 37.0098C28.8516 36.6191 28.9834 36.292 29.2471 36.0283C29.5205 35.7549 29.8525 35.6182 30.2432 35.6182H49.0371C49.4277 35.6182 49.7549 35.7549 50.0186 36.0283C50.292 36.292 50.4287 36.6191 50.4287 37.0098C50.4287 37.4004 50.292 37.7324 50.0186 38.0059C49.7549 38.2695 49.4277 38.4014 49.0371 38.4014H30.2432ZM30.2432 46.9707C29.8525 46.9707 29.5205 46.8389 29.2471 46.5752C28.9834 46.3018 28.8516 45.9697 28.8516 45.5791C28.8516 45.1885 28.9834 44.8564 29.2471 44.583C29.5205 44.3096 29.8525 44.1729 30.2432 44.1729H49.0371C49.4277 44.1729 49.7549 44.3096 50.0186 44.583C50.292 44.8564 50.4287 45.1885 50.4287 45.5791C50.4287 45.9697 50.292 46.3018 50.0186 46.5752C49.7549 46.8389 49.4277 46.9707 49.0371 46.9707H30.2432ZM23.6074 30.4766C23.0508 30.4766 22.5723 30.2812 22.1719 29.8906C21.7715 29.4902 21.5713 29.0068 21.5713 28.4404C21.5713 27.8838 21.7715 27.4053 22.1719 27.0049C22.5723 26.6045 23.0508 26.4043 23.6074 26.4043C24.1738 26.4043 24.6523 26.6045 25.043 27.0049C25.4434 27.4053 25.6436 27.8838 25.6436 28.4404C25.6436 29.0068 25.4434 29.4902 25.043 29.8906C24.6523 30.2812 24.1738 30.4766 23.6074 30.4766ZM23.6074 39.0459C23.0508 39.0459 22.5723 38.8506 22.1719 38.46C21.7715 38.0596 21.5713 37.5762 21.5713 37.0098C21.5713 36.4531 21.7715 35.9746 22.1719 35.5742C22.5723 35.1738 23.0508 34.9736 23.6074 34.9736C24.1738 34.9736 24.6523 35.1738 25.043 35.5742C25.4434 35.9746 25.6436 36.4531 25.6436 37.0098C25.6436 37.5762 25.4434 38.0596 25.043 38.46C24.6523 38.8506 24.1738 39.0459 23.6074 39.0459ZM23.6074 47.6152C23.0508 47.6152 22.5723 47.415 22.1719 47.0146C21.7715 46.6143 21.5713 46.1357 21.5713 45.5791C21.5713 45.0225 21.7715 44.5439 22.1719 44.1436C22.5723 43.7432 23.0508 43.543 23.6074 43.543C24.1738 43.543 24.6523 43.7432 25.043 44.1436C25.4434 44.5439 25.6436 45.0225 25.6436 45.5791C25.6436 46.1357 25.4434 46.6143 25.043 47.0146C24.6523 47.415 24.1738 47.6152 23.6074 47.6152Z"
          fill={focused ? theme.palette.new.playerButton : "white"}
        />
      </svg>
    </Box>
  )
}
